export const DASHBOARD_SLICE_NAME = "dashboard"
